var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridColumn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02083 15.3127H6.85417V4.68766H3.02083V15.3127ZM8.10417 15.3127H11.8958V4.68766H8.10417V15.3127V15.3127ZM13.1458 15.3127H16.9792V4.68766H13.1458V15.3127V15.3127ZM3.02083 16.9585C2.57639 16.9585 2.19097 16.7953 1.86458 16.4689C1.53819 16.1425 1.375 15.7571 1.375 15.3127V4.68766C1.375 4.22933 1.53819 3.83697 1.86458 3.51058C2.19097 3.18419 2.57639 3.021 3.02083 3.021H16.9792C17.4375 3.021 17.8299 3.18419 18.1563 3.51058C18.4826 3.83697 18.6458 4.22933 18.6458 4.68766V15.3127C18.6458 15.7571 18.4826 16.1425 18.1563 16.4689C17.8299 16.7953 17.4375 16.9585 16.9792 16.9585H3.02083Z",
    fill: "#646569"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridColumn);
export default __webpack_public_path__ + "static/media/Grid_column.eb850c33d3e48ccb46990b624166ef94.svg";
export { ForwardRef as ReactComponent };